import ActionType from './ActionType';
import axios from 'axios';


const createExpertTeamAction=(expertTeamJson)=>{
    return{
        type:ActionType.FETCH_JWEXPERTTEAN,
        data:expertTeamJson
    }
}


export const fetch_expertTeam=(method,params)=>{
    return (dispatch)=>{
        axios({
            url:'/api/ColumnInfo',
            baseURL:'http://39.105.107.26',
            method:method,
            params:params,
            headers:{
                'Content-Type':'application/json;charset=utf-8',
            }
        }).then((response)=>{
            dispatch(createExpertTeamAction(response.data.data))
        }).catch((error)=>{
            console.log(error)
        });
    }
}

